// Označení starých událostí přeškrtnutím
import { annotate } from 'rough-notation';

function markExpiredEvents() {
  // Najdeme všechny overlay elementy pro staré události
  const expiredOverlays = document.querySelectorAll('.expired-overlay');
  
  if (expiredOverlays.length > 0) {
    // Vytvoříme anotace pro všechny staré události
    const annotations = Array.from(expiredOverlays).map(overlay => {
      // Anotujeme overlay element
      const annotation = annotate(overlay, {
        type: 'crossed-off',
        color: '#000000',
        strokeWidth: 1,
        padding: 0,
        animate: true,
        animationDuration: 800,
        iterations: 2
      });
      return annotation;
    }).filter(Boolean);
    
    // Spustíme animaci postupně - jeden po druhém
    setTimeout(() => {
      annotations.forEach((annotation, index) => {
        setTimeout(() => {
          annotation.show();
        }, index * 200); // 200ms zpoždění mezi každým přeškrtnutím
      });
    }, 1000); // Začneme po 1 sekundě
  }
}

// Spustíme po načtení DOM
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(markExpiredEvents, 500);
});

// Spustíme také při Turbo navigaci (pro SPA chování)
document.addEventListener('turbo:load', () => {
  setTimeout(markExpiredEvents, 500);
});

document.addEventListener('turbo:render', () => {
  setTimeout(markExpiredEvents, 500);
});
